import { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  IconButton,
} from "@material-ui/core";

import { Close, Category } from "@mui/icons-material";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import InputText from "components/_refactor/text/input";

const FORM_TYPES = {
  CREATE: "create",
  EDIT: "edit",
  REMOVE: "remove",
};

export default function DialogCreateEdit({
  open,
  onClose,
  refresh,
  selectedRow,
  typeForm,
}) {
  const snackbar = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [nome, setNome] = useState(selectedRow?.Nome || "");
  const [descricao, setDescricao] = useState(selectedRow?.Descricao || "");

  const resetForm = () => {
    setNome("");
    setDescricao("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleRefresh = () => {
    resetForm();
    refresh();
  };

  const handleCreate = async () => {
    try {
      const res = await Api.post(
        "create-categoria",
        "conteudo",
        {
          nome,
          descricao,
        },
        true
      );
      if (res.Success) {
        snackbar.showMessage("Categoria criada com sucesso!", {
          severity: "success",
        });
        handleClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao criar categoria", {
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    try {
      const res = await Api.put(
        "edit-categoria",
        "conteudo",
        {
          idCategoria: selectedRow?.IdDocumentoAreaCategoria,
          nome,
          descricao,
        },
        true
      );
      if (res.Success) {
        snackbar.showMessage("Categoria atualizada com sucesso!", {
          severity: "success",
        });
        handleClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao atualizar categoria", {
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      const res = await Api.put(
        "delete-categoria",
        "conteudo",
        {
          idCategoria: selectedRow?.IdDocumentoAreaCategoria?.toString(),
        },
        true
      );
      if (res.Success) {
        snackbar.showMessage("Categoria excluída com sucesso!", {
          severity: "success",
        });
        handleClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao excluir categoria", {
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    setLoading(true);

    if (typeForm === FORM_TYPES.REMOVE) {
      return handleDelete();
    }

    if (typeForm === FORM_TYPES.EDIT) {
      return handleEdit();
    }

    return handleCreate();
  };

  const isFormValid = () => {
    return nome.trim() !== "" && descricao.trim() !== "" && !loading;
  };

  const getDialogTitle = () => {
    switch (typeForm) {
      case FORM_TYPES.EDIT:
        return "Editar";
      case FORM_TYPES.REMOVE:
        return "Excluir";
      default:
        return "Adicionar";
    }
  };

  const getButtonText = () => {
    if (typeForm === FORM_TYPES.REMOVE) {
      return "Confirmar";
    }
    return typeForm === FORM_TYPES.CREATE ? "Criar" : "Atualizar";
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Category style={{ marginRight: "12px" }} />
            {`${getDialogTitle()} Categoria`}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        {typeForm === FORM_TYPES.REMOVE ? (
          <Typography variant="h4">
            Confirmar exclusão da categoria "{selectedRow?.Nome}"?
          </Typography>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputText
                label="Nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                disabled={loading}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <InputText
                label="Descrição"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                disabled={loading}
                required
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={typeForm === FORM_TYPES.REMOVE ? loading : !isFormValid()}
        >
          {getButtonText()}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
